import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

import * as actions from './RouterActions'

export class AdminOnlyRoute extends Component {
    componentWillMount() {
        const { authenticate, isLogin } = this.props
        const token = localStorage.getItem('token')

        if (isLogin !== true)
			authenticate(token)
    }

    render() {
        const { isLogin, userType, component, ...rest } = this.props

        if (isLogin != null && userType !== '')
            return (
                <Route 
		        	{...rest } 
		        	render={ props => userType === 'admin' ? React.createElement(component, props) : <Redirect to="/workdesk"/> }
		        />
            )
        else
            return <div></div>
    }
}

const mapStateToProps = (state) => {
    return {
        isLogin: state.auth.isLogin,
        userType: state.auth.userType
    }
}

export default connect(mapStateToProps, actions)(AdminOnlyRoute)



// WEBPACK FOOTER //
// ./src/Router/AdminOnlyRoute.js